import React from 'react'
import OTPInput from '../../../components/common/OtpInput'
import SetPasswordForm from '../components/SetPasswordForm'
import { Label } from '../../../styles/newStyles/Register.styled'
import { Text } from '../../../modules/staking'

const ForgetPassword = ({
    inputValues,
    otpInputRef,
    verifyCode,
    onVerifyCodeChange,
    timer,
    onOtpResend,
    verifyData,
    authCode,
    setAuthCode,
    password,
    setPassword,
    setValidationStatus,
}) => {


    return (
        <div className='flex flex-col gap-2'>
            <>
                <div className='flex justify-between gap-1 items-center'>
                    <Label>
                        <Text tid={'code-sent_part-1'} />
                        <span className='text-xs text-main'>{" "} {inputValues.mobileOrEmail} {" "}</span>
                        <Text tid={'code-sent_part-2'} />
                    </Label>
                    {/* <button
                        className='group py-2 text-xs sm:text-sm'
                        onClick={() => { Navigate('/auth/signin') }}
                    >
                        <Text tid='edit-mobile/email' className='group-hover:text-active' />
                    </button> */}
                </div>
                <OTPInput
                    ref={otpInputRef}
                    value={verifyCode}
                    autoFocus={true}
                    onOtpChange={onVerifyCodeChange}
                />
                {timer > 0 ? (
                    <p className='flex items-center text-gray-500 text-sm'>
                        <Text tid='get-code' />
                        {' : '}
                        {timer}
                    </p>
                ) : (
                    <p className='cursor-pointer hover:text-active text-sm' onClick={onOtpResend}>
                        <Text tid={'get-code'} />
                    </p>
                )}
            </>
            <SetPasswordForm
                setValidationStatus={setValidationStatus}
                password={password}
                onPasswordChange={setPassword}
            />
        </div>
    )
}

export default ForgetPassword